import { ReconciliationNonConsecutiveStatementsDatesError } from "@common/contracts/reconciliation.contract";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { ErrorToast } from "@design-system/ToastMessages/ErrorToast";
import { format, parseISO } from "date-fns";

interface Props {
    error: ReconciliationNonConsecutiveStatementsDatesError;
}

export const ReconciliationNonConsecutiveStatementsDatesErrorToast: React.FC<
    Props
> = ({ error }) => {
    const previousStatementClosingDate = parseISO(
        error.previousStatementClosingDate,
    );
    const currentStatementOpeningDate = parseISO(
        error.currentStatementOpeningDate,
    );

    return (
        <ErrorToast>
            <div>
                Uploaded statements are not consecutive.{" "}
                {format(previousStatementClosingDate, fullDateFullYearFormat)}{" "}
                closing date (<strong>{error.previousStatementFileName}</strong>
                ) →{" "}
                {format(currentStatementOpeningDate, fullDateFullYearFormat)}{" "}
                opening date (<strong>{error.currentStatementFileName}</strong>
                ).
            </div>
        </ErrorToast>
    );
};
